export class VerifyRdsCdcSqlSetupResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "workflowId",
            "baseName": "workflowId",
            "type": "string",
            "format": ""
        },
        {
            "name": "workflowNamespace",
            "baseName": "workflowNamespace",
            "type": "string",
            "format": ""
        },
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VerifyRdsCdcSqlSetupResponse.attributeTypeMap;
    }
    constructor() {
    }
}
